export class MainActionData {
	closeable = false;

	/**
	 *
	 * @param {string} nameCallbackId
	 * @param {string} callback - globally accessible
	 * @param {object} attributes
	 */
	constructor(nameCallbackId, callbackId, attributes = {}) {
		this.nameCallbackId = nameCallbackId;
		this.callbackId = callbackId;
		this.attributes = attributes;
	}

	static from({ nameCallbackId = null, callbackId = null, attributes = {} }) {
		return new MainActionData(nameCallbackId, callbackId, attributes);
	}
}
